import localstore from '@/utils/localStore'
import userTypes from '@/store/types/user'
import store from '@/store/index'

// 菜单权限内存缓存：
// 原实现将菜单数据持久化在 localStorage，后台调整权限后前端仍读取旧缓存，
// 必须手动清理浏览器缓存才能看到最新权限。
// 改为内存缓存后：同一会话内复用缓存，刷新页面（重新加载）后自动重新请求后端，
// 权限配置变更即时生效，无需清理浏览器缓存。
let subMenuCache = null
let mainMenuCache = null
let subMenuPromise = null
let mainMenuPromise = null

// 加载并缓存子菜单，避免同会话内并发重复请求
function loadSubMenu () {
  if (subMenuCache) return Promise.resolve(subMenuCache)
  if (!subMenuPromise) {
    subMenuPromise = store.dispatch(userTypes.GET_MENU, { Grade: 1 })
      .then(data => {
        subMenuCache = data
        return data
      })
      .then(() => { subMenuPromise = null }, () => { subMenuPromise = null })
  }
  return subMenuPromise
}

// 加载并缓存顶部主菜单
function loadMainMenu () {
  if (mainMenuCache) return Promise.resolve(mainMenuCache)
  if (!mainMenuPromise) {
    mainMenuPromise = store.dispatch(userTypes.GET_MENU, { Grade: 0 })
      .then(data => {
        mainMenuCache = data
        return data
      })
      .then(() => { mainMenuPromise = null }, () => { mainMenuPromise = null })
  }
  return mainMenuPromise
}

// 同步获取子菜单缓存，供全局组件在菜单加载完成后读取
export function getSubMenuCache () {
  return subMenuCache
}

// 公用方法组件
export default {
  install: function (Vue, options) {
    Vue.prototype.ListSubMenu = async function (mainName) {
      var res = []
      var uniqueList = []
      await loadSubMenu()
      if (subMenuCache) {
        subMenuCache.forEach(element => {
          if (mainName === element.menuInfo.name) {
            var subList = element.chidMenuInfo
            subList.forEach(item => {
              if (uniqueList.indexOf(item.menuInfo.name) < 0) {
                res.push({
                  name: item.menuInfo.name,
                  imgid: item.menuInfo.imgid,
                  type: item.menuInfo.url,
                  state: item.menuInfo.isCheck,
                  meta: mainName,
                  isLink: item.menuInfo.isLink
                })
                uniqueList.push(item.menuInfo.name)
              }
            })
          }
        })
      }
      return res
    }

    Vue.prototype.ListMainMenu = async function () {
      let res = []
      await loadMainMenu()
      if (mainMenuCache) {
        res.push({ name: '工作台', type: 'Homepage' })
        mainMenuCache.forEach(element => {
          if (!element.menuInfo.topColumn) {
            res.push({ name: element.menuInfo.name, type: element.menuInfo.url, isLink: element.menuInfo.isLink })
          }
        })
      }
      return res
    }

    // 路由权限验证
    Vue.prototype.checkRouter = async function (name) {
      let names = []
      await loadSubMenu()
      if (subMenuCache) {
        getName(subMenuCache, names)
      }
      return names.find(el => { return el === name })
    }

    Vue.prototype.CheckOperateFunctions = function (mainName, type) {
      var res = {}
      // 优先使用内存缓存，未加载完成时兜底读取 localStorage 旧数据
      var menu = subMenuCache || localstore.getItem('subMenu')

      if (menu) {
        menu.forEach(element => {
          if (mainName === element.menuInfo.name) {
            var subList = element.chidMenuInfo
            if (subList) {
              subList.forEach(item => {
                if (type === item.menuInfo.url) {
                  res[item.menuInfo.desc] = true
                }
              })
            }
          }
        })
      }

      return res
    }

    // 获取今日格式化的时间
    Vue.prototype.getNowFormatDate = function (date) {
      // var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }
  }
}

function getName (arr, names) {
  for (let i = 0; i < arr.length; i++) {
    names.push(arr[i].menuInfo.url)
    if (arr[i].chidMenuInfo) {
      getName(arr[i].chidMenuInfo, names)
    }
  }
}
